import "./App.css";
import MainPage from "./pages/StaffTablePage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FrontDeskPage from "./pages/FrontDeskPage";
import SettingsPage from "./pages/SettingsPage";
import StaffManagementPage from "./pages/StaffManagementPage";
import "@aws-amplify/ui-react/styles.css";
import { withAuthenticator } from "@aws-amplify/ui-react";
import {
  IUserContext,
  UserContext,
  UserContextProvider,
} from "./common/context";
import { AuthUser } from "aws-amplify/auth";
import { useContext } from "react";
interface AppProps {
  user: AuthUser;
}

function App({ user }: AppProps) {
  return (
    <div className="App">
      <UserContextProvider user={user}>
        <NolasRouter></NolasRouter>
      </UserContextProvider>
    </div>
  );
}

function NolasRouter() {
  const { user } = useContext<IUserContext>(UserContext);
  if (!user) {
    return <div></div>;
  }
  return user.role == "member" ? (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FrontDeskPage />} />
        <Route path="/frontdesk" element={<FrontDeskPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route
          path="/staffs/:staffToken"
          element={<StaffManagementPage></StaffManagementPage>}
        />
      </Routes>
    </BrowserRouter>
  ) : (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/frontdesk" element={<FrontDeskPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route
          path="/staffs/:staffToken"
          element={<StaffManagementPage></StaffManagementPage>}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default withAuthenticator(App);
